<div class="pag-container">

  <app-campaign-3-breadcrumb *ngIf="showBreadCrumb" [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink="">
  </app-campaign-3-breadcrumb>

<div class="page-header">
  <div>
    <h1 class="bold-text header-blue" style="margin-top:20px">
      {{ 'baskets.actionListTitle' | translate }}
    </h1>

    <h3 class="thin-text header-blue">
      {{ 'baskets.actionListDescription' | translate }} {{ basketId }}
    </h3>

  </div>
  <div>
    <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" (click)="onGoBack()"
      [label]="'common.back' | translate">
    </button>
  </div>
</div>


  <div class="ui-g-12" *ngIf="showTable">

    <app-campaign-3-kontable #promoListDetailKontable [columns]="[
        { field: 'id', title: 'baskets.id', filterType: textFilter },
        { field: 'campaign_name', title: 'baskets.campaignName', filterType: textFilter },
        { field: 'name', title: 'baskets.actionName', filterType: textFilter },
        {
          field: 'rule_scope',
          title: 'baskets.scope',
          filterType: selectFilter,
          filterOptions: { values: scopeList },
          bodyTemplate: rulescopeTemplate
        },
        {
          field: 'code',
          title: 'baskets.emission',
          filterType: noFilter,
          bodyTemplate: emissionTemplate,
          sortable: false
        },
        {
          field: 'code',
          title: 'baskets.fruition',
          filterType: noFilter,
          bodyTemplate: fruitionTemplate,
          sortable: false
        },
        {
          field: 'active',
          title: 'baskets.status',
          filterType: customFilter,
          bodyTemplate: statusTemplate,
          filterTemplate: statusTemplateFilterCol
        }
      ]" [paginationType]="paginationType" [showInfoButton]="false" [showDetailsButton]="false"
      [showRecoverButton]="false" [showAddButton]="false" [showDeleteButton]="false" [showEditButton]="false"
      [allowSelectRow]="false" [additionalRowCommands]="actions" [filterBySingleColumn]="true"
      [source]="basketActionList">

      <ng-template #statusTemplateFilterCol let-col>
        <p-dropdown [options]="actionStatusList" (onChange)="loadBasketActions(this.basketId ,$event.value)"
          [(ngModel)]="promoListDetailKontable.filter.search[col.field]"></p-dropdown>
      </ng-template>
      <!-- STATUS -->
      <ng-template #statusTemplate let-row>
        <span class="center-number">
          {{ translateState(row.active) }}
        </span>
      </ng-template>

      <!-- RULE SCOPE -->
      <ng-template #rulescopeTemplate let-row>
        <span class="center-number">
          {{ translateRuleScope(row.rule_scope) }}
        </span>
      </ng-template>

      <!-- EMISSION -->
      <ng-template #emissionTemplate let-row>
        <div class="template-column">
          <span>{{ row.start_emission_date }}</span>
          <span>{{ row.end_emission_date }}</span>
        </div>
      </ng-template>

      <!-- FRUITION -->
      <ng-template #fruitionTemplate let-row>
        <div class="template-column">
          <span>{{ row.start_fruition_date }}</span>
          <span>{{ row.end_fruition_date }}</span>
        </div>
      </ng-template>

      <!-- ACTIONS -->
      <ng-template #actions let-row>
        <div class="d-flex justify-content-center">
          <button data-testid-generic="goToAction" [attr.data-testid]="'goToAction' + row.id"
            (click)="goToActionDetail(row)" pTooltip="{{ 'baskets.goToAction' | translate }}"
            class="roundedButton row-buttom-margin">
            <i class="pi pi-eye icon-size"></i>
          </button>
        </div>
      </ng-template>

    </app-campaign-3-kontable>

  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/baskets/basket-action-list/basket-action-list.component.html